import React from 'react';
import ParticipantsView from '@/scenes/Event/scenes/Recruiter/scenes/Jobdating/container/ParticipantsView';

const RecruiterJobdatingTopScene = () => (
      <ParticipantsView context="top" />
    )

export default RecruiterJobdatingTopScene;
